<template>
  <b-col cols="12" sm="6" md="6" lg="4" xl="3" class="mb-4">
    <b-card no-body>
      <b-card-body>
        <div class="mb-1 text-truncate">
          <span
            class="name-link"
            :id="'user-link-' + product.id"
            @click="showUserInfo = !showUserInfo"
          >
            <font-awesome-icon icon="user-alt" class="icon-link"/>
            <span class="ml-2">{{ product.owner_info.full_name }}</span>
          </span>
        </div>
        <b-popover
          :target="'user-link-' + product.id"
          :title="product.owner_info.full_name"
          triggers="hover"
          placement="top"
          :show.sync="showUserInfo"
          :content="product.owner_info.full_name"
        >
          <a
            v-if="product.owner_info.phone"
            :href="'tel:' + product.owner_info.phone"
             class="name-link d-block my-3"
          >
            <font-awesome-icon icon="phone" class="icon-link"/>
            <span class="ml-2">{{ product.owner_info.phone }}</span>
          </a>
          <a
            v-if="product.owner_info.email"
            :href="'mailto:' + product.owner_info.email"
             class="name-link d-block mb-3"
          >
            <font-awesome-icon icon="envelope" class="icon-link"/>
            <span class="ml-2">{{ product.owner_info.email }}</span>
          </a>
        </b-popover>
        <div
          v-if="product.ad_info.ad_host === client"
          class="d-flex justify-content-between"
        >
          <div
            v-if="canReserve"
            class="name-link mb-1"
            @click="reserve"
          >
            <font-awesome-icon icon="calendar" class="icon-link"/>
            <span class="ml-2 text-truncate">Reservar cita</span>
          </div>
          <div
            v-if="canModifyAppointment"
            class="name-link mb-1"
            @click="reserve"
          >
            <font-awesome-icon icon="calendar" class="icon-link"/>
            <span class="ml-2 text-truncate">Modificar cita</span>
          </div>
          <div
            v-if="canBeValidated"
            class="name-link mb-1"
            @click="validate"
          >
            <font-awesome-icon icon="check-double" class="icon-link"/>
            <span class="ml-2 text-truncate">Validar</span>
          </div>
        </div>
        <div
          v-if="product.id_status === 'c' || product.id_status === 'd'"
          class="mb-1 info-placeholder"
        />
        <hr>
        <status-line :product="product"/>

        <div class="image-container">
          <img :src="productImage" class="card-img" alt="...">
          <font-awesome-icon
            icon="desktop"
            class="preview-link icon-link"
            size="lg"
            @click="launchPreview"
          />
        </div>

        <div class="ad-name my-1">
          {{ product.ad_info.name }}
        </div>
        <div class="mb-1 text-truncate">
          <span>Fecha compra:</span>
          <time-slot :value="product.created"/>
        </div>
        <div class="d-flex justify-content-between mt-2">
          <div class="value-line mb-1">
            <span>Id:</span>
            <span class="ml-1 text-secondary">{{ product.id }}</span>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-2">
          <div class="value-line mb-1">
            <span>Número de pedido:</span>
            <span class="ml-1 text-secondary">{{ product.id_order }}</span>
          </div>
        </div>
      </b-card-body>
      <b-card-footer v-if="footerVissible">
        <div
          class="d-flex justify-content-between mt-2"
        >
        </div>
      </b-card-footer>
    </b-card>
  </b-col>
</template>

<script>
import TimeSlot from '../common/TimeSlot'
import StatusLine from './StatusLine'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'ProductCard',
  components: { StatusLine, TimeSlot },
  props: ['product'],
  computed: {
    ...mapGetters(['siteUrl']),
    ...mapGetters('clients', ['client']),
    productImage () {
      return this.product.ad_info.image
    },
    hasReserved () {
      return this.product.reservation && this.product.reservation > '0000-00-00 00:00:00'
    },
    canBeValidated () {
      return this.product.id_status === 'p' || (this.product.id_status === 'v' && this.product.reserved)
    },
    canReserve () {
      return this.product.id_status === 'p'
    },
    canModifyAppointment () {
      return this.product.id_status === 'v' && this.product.reserved
    },
    didNotAssist () {
      return this.product.id_status === 'v' && this.product.reservation && this.product.reservation <= this.now
    },
    footerVissible () {
      return false
    },
    now () {
      return moment().format('YYYY-MM-DD HH:mm:ss')
    }
  },
  data () {
    return {
      showUserInfo: false,
      showClientInfo: false
    }
  },
  methods: {
    ...mapActions('products', ['setCurrentProduct']),
    launchPreview () {
      const url = this.siteUrl + '/sponsor/viewAd/' + this.client + '/0/' + this.product.id_ad
      const win = window.open(url, '_blank')
      win.focus()
    },
    reserve () {
      this.setCurrentProduct(this.product)
      this.$bvModal.show('product-adm-reservation-modal')
    },
    validate () {
      this.setCurrentProduct(this.product)
      this.$bvModal.show('product-adm-validation-modal')
    },
    showResult (data) {
      if (data.success === 'true') {
        this.makeToast(data.heading, data.message, 'success')
      } else {
        this.makeToast(data.heading, data.message, 'danger')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .card {
    border: 1px solid #88BD2F;
    font-size: 15px;
  }

  .name-link {
    &:hover {
      opacity: 0.5;
      cursor: pointer;
    }
  }

  .info-placeholder {
    height: 24px;
  }

  .ad-name {
    font-size: 17px;
  }

  hr {
    color: #88BD2F;
  }

  .value-line {
    line-height: 1;
  }

  .image-container {
    position: relative;
  }

  .preview-link {
    position: absolute;
    bottom: 0.5rem;
    right: 0.5rem;
    background-color: white;
    color: #88BD2F;
    padding: 0.2rem;
  }
</style>
